import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { useFormik } from "formik";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { actions } from "../redux/authRedux";
import * as Yup from "yup";
import "../../src/assets/css/login.css";
import { confirmAlert } from "react-confirm-alert";
import Spinner from "../component/Spinner";
import sign from "jwt-encode";
import { useParams } from "react-router-dom";
import Cookies from 'js-cookie';
import noibo from "../assets/img/bhs-noibo-logo.png";
import configData from "../configs/config.json";
import { useRef } from "react";
export default function Login() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({ isAuthorized: auth.user != null }),
    shallowEqual
  );

  const { hash } = useParams();
  const ssoPopupRef = useRef(null);
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();

  const createConfig = (_token) => {
    return {
      headers: {
        'Authorization': 'Bearer ' + _token,
        'Content-Type': 'application/json; charset=UTF-8',
        'search': ''
      }
    }
  }

  const ValidSchema = Yup.object().shape({
    username: Yup.string().trim().nullable().required("Vui lòng nhập tên đăng nhập"),
    password: Yup.string().trim().nullable().min(6, "Mật khẩu có độ dài tối thiểu 6 ký tự").max(150, "Mật khẩu có độ dài tối đa 150 ký tự").required("Vui lòng nhập mật khẩu"),
  });


  const formik = useFormik({
    initialValues: { username: '', password: '' },
    validationSchema: ValidSchema,
    onSubmit: (values, { setSubmitting }) => {
      const secure = sign(values, configData.secret_key);
      // console.log(secure);
      setLoading(true)
      Axios.post(URL_LIST_ALL + "ldaplogin", { data: secure })
        .then((res) => {
          setSubmitting(false);
          setLoading(false)
          if (res.data.status === "success") {
            let user = res.data;
            user.config = createConfig(res.data.access_token);
            // console.log(user);
            dispatch(actions.login(user));
          } else alert(res.data.message)
        }).catch((err) => { console.log(err); setLoading(true) });
    },
  });

  const formikMK = useFormik({
    initialValues: { email: '', code: '' },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      email: Yup.string().trim().nullable().required('Nhập email').max(150, "Độ dài không quá 150 ký tự"),
      code: Yup.string().trim().nullable().required('Nhập mã nhân viên').max(15, "Độ dài không quá 15 ký tự"),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      setLoading(true)

      Axios.post(URL_LIST_ALL + 'quen-mat-khau', values).then(res => {
        setLoading(false);
        setSubmitting(false);
        if (res.data.status === "success") {
          resetForm();
          confirmAlert({
            title: 'Thành công',
            message: 'Mật khẩu mới đã được gửi tới email ' + values.email + '. Vui lòng kiểm tra email',
            buttons: [{ label: 'OK' }]
          });
          document.cookie = "ssohash=;path=/;domain=bhsgroup.vn";
        } else {
          confirmAlert({
            title: 'Lỗi',
            message: res.data.message,
            buttons: [{ label: 'OK' }]
          });
        }
      }).catch(err => console.log(err));

    },
  });

  useEffect(function () {
    if (Cookies.get('ssohash') && Cookies.get('ssohash') !== '' && Cookies.get('ssohash') !== 'logout') {
      let ssohash = Cookies.get('ssohash')
      // console.log(ssohash);
      // Axios.post(URL_LIST_ALL + "loginhash", { ssohash: ssohash }).then((res) => {
      //   if (res.data.status === "success") {
      //     let user = res.data;
      //     user.config = createConfig(res.data.access_token);
      //     dispatch(actions.login(user));
      //   } else alert(res.data.message)
      // }).catch((err) => console.log(err));
    }
  }, [hash]);

  useEffect(() => {
    const handleSsoMessage = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }

      if (!event.data || event.data.type !== "HRM_SSO_LOGIN_SUCCESS" || !event.data.payload) {
        return;
      }

      dispatch(actions.login(event.data.payload));
      setLoading(false);

      if (ssoPopupRef.current && !ssoPopupRef.current.closed) {
        ssoPopupRef.current.close();
      }
    };

    window.addEventListener("message", handleSsoMessage);

    return () => {
      window.removeEventListener("message", handleSsoMessage);
    };
  }, [dispatch]);

  const openSsoPopup = () => {
    const width = 520;
    const height = 720;
    const left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
    const top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);

    ssoPopupRef.current = window.open(
      "/login-sso",
      "hrm_sso_login",
      `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes`
    );

    if (!ssoPopupRef.current) {
      window.location.href = "/login-sso";
      return;
    }

    ssoPopupRef.current.focus();
  };

  return (
    <div>
      {isAuthorized ? (
        <Redirect to="/" />
      ) : (
        <div className="layout-login">
          <div className="container btn-login-gr">
            <div className="mb-3 w-100 d-flex justify-content-center">
              <img src={noibo} alt="logo" width={300} />
            </div>
            <div className="mt-3 w-100 d-flex justify-content-center">
              <div className="wrap-login100 p-t-50 p-b-30">


                {/* Từ 03/11/2026 CHỈ đăng nhập bằng SSO (BAuths).
                    Form tài khoản/mật khẩu đã gỡ khỏi giao diện để người dùng quen
                    với một lối vào duy nhất; SSO đã tách tài khoản nội bộ và tài
                    khoản ngoài nên mọi nhân sự đều đăng nhập được.
                    Backend vẫn giữ endpoint đăng nhập cũ (chưa gỡ) phòng khi cần
                    mở lại — muốn chặn triệt để thì phải tắt ở backend, không chỉ ẩn
                    nút ở đây. */}
                <div className="login100-form">
                  <div className="container-login100-form-btn">
                    <button
                      type="button"
                      className="login100-form-btn"
                      onClick={openSsoPopup}
                    >
                      Đăng nhập với tài khoản BAuths
                    </button>
                    <div className="text-center text-white w-100 mt-4">
                      Đối với nhân viên mới, anh chị vui lòng đăng nhập webmail <a className="text-danger" target="_blank" rel="noreferrer" href="https://mail.bhsgroup.vn/">mail.bhsgroup.vn</a> để kích hoạt tài khoản trước khi đăng nhập hệ thống
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
